import Vue from "vue";
import Router from "vue-router";

const Register = () => import("@/views/Register");
const Login = () => import("@/views/Login");
const Layout = () => import("@/views/Layout");
const Home = () => import("@/views/Home/Home");
const StaffList = () => import("@/views/Staff/List");
const OrganizationList = () => import("@/views/Organization/List");
const SelfApps = () => import("@/views/Application/SelfApps/SelfApps");
const SelfAppConfig = () => import("@/views/Application/SelfApps/AppConfig");
const SelfAppRole = () => import("@/views/Application/SelfApps/RootRole");
const SelfAppGroup = () => import("@/views/Application/SelfApps/GroupRole");
const ThirdApps = () => import("@/views/Application/ThirdApps");
const Bookmark = () => import("@/views/Application/Bookmark");
const AppVerify = () => import("@/views/Verification/AppVerify");
const LoginVerify = () => import("@/views/Verification/LoginVerify");
const Audit = () => import("@/views/Security/Audit");
const Agent = () => import("@/views/Security/Agent");
const Log = () => import("@/views/Security/Log");
const IP = () => import("@/views/Security/IP");
const Notice = () => import("@/views/Security/Notice");
const Records = () => import("@/views/Security/Records");
const Domain = () => import("@/views/System/Domain");
const RootsOld = () => import("@/views/System/RootsOld");
const Roots = () => import("@/views/System/Roots");
const RootsUpdate = () => import("@/views/System/RootsUpdate");
const Desktop = () => import("@/views/Desktop/Index");
const Activation = () => import("@/views/Activation");
const Sso = () => import("@/views/Sso");
const CustomerField = () => import("@/views/Customer/Field");
const AppProxy = () => import("@/views/ProxyConfig/AppProxy");
const Certificates = () => import("@/views/ProxyConfig/Certificates");
const FlowControl = () => import("@/views/ProxyConfig/FlowControl");
const ForwardProxy = () => import("@/views/ProxyConfig/ForwardProxy");
const IPMac = () => import("@/views/ProxyConfig/IPMac");
const NodeConfig = () => import("@/views/ProxyConfig/NodeConfig");
const SafetyRules = () => import("@/views/ProxyConfig/SafetyRules");

Vue.use(Router);

export default new Router({
  mode: "history",
  routes: [
    {
      path: "*",
      redirect: "/login"
    },
    {
      path: "/login",
      name: "Login",
      component: Login,
      meta: {
        isLogin: false,
        title: "登录"
      }
    },
    {
      path: "/register",
      name: "Register",
      component: Register,
      meta: {
        isLogin: false,
        title: "注册"
      }
    },
    {
      path: "/activation",
      name: "Activation",
      component: Activation,
      meta: {
        isLogin: false,
        title: "账号激活"
      }
    },
    {
      path: "/desktop",
      name: "Desktop",
      component: Desktop,
      meta: {
        isLogin: true,
        title: "职员工作台"
      }
    },
    {
      path: "/sso",
      name: "Sso",
      component: Sso,
      meta: {
        isLogin: false,
        title: "授权登录"
      }
    },
    {
      path: "/layout",
      name: "Layout",
      component: Layout,
      meta: {
        isLogin: true
      },
      children: [
        {
          path: "/home",
          name: "Home",
          component: Home,
          meta: {
            isLogin: true,
            title: "企业管理中心"
          }
        },
        {
          path: "/staff",
          name: "StaffList",
          component: StaffList,
          meta: {
            isLogin: true,
            title: "职员管理"
          }
        },
        {
          path: "/organization",
          name: "OrganizationList",
          component: OrganizationList,
          meta: {
            isLogin: true,
            title: "组织管理"
          }
        },
        {
          path: "/selfApps",
          name: "SelfApps",
          component: SelfApps,
          meta: {
            isLogin: true,
            title: "自建应用"
          }
        },
        {
          path: "/selfAppsConfig",
          name: "SelfAppConfig",
          component: SelfAppConfig,
          meta: {
            isLogin: true,
            title: "应用详情"
          }
        },
        {
          path: "/selfAppsRole",
          name: "SelfAppRole",
          component: SelfAppRole,
          meta: {
            isLogin: true,
            title: "角色详情"
          }
        },
        {
          path: "/selfAppsGroup",
          name: "SelfAppGroup",
          component: SelfAppGroup,
          meta: {
            isLogin: true,
            title: "组别详情"
          }
        },
        {
          path: "/thirdApps",
          name: "ThirdApps",
          component: ThirdApps,
          meta: {
            isLogin: true,
            title: "第三方应用"
          }
        },
        {
          path: "/bookmark",
          name: "Bookmark",
          component: Bookmark,
          meta: {
            isLogin: true,
            title: "书签管理"
          }
        },
        {
          path: "/applicationManage",
          name: "applicationManage",
          component: () => import('../views/Customer/ApplicationManage.vue'),
          meta: {
            isLogin: true,
            title: "应用管理"
          }
        },
        {
          path: "/users",
          name: "users",
          component: () => import('../views/Customer/Users.vue'),
          meta: {
            isLogin: true,
            title: "用户管理"
          }
        },
        {
          path: "/customerField",
          name: "CustomerField",
          component: CustomerField,
          meta: {
            isLogin: true,
            title: "字段管理"
          }
        },
        {
          path: "/appVerify",
          name: "AppVerify",
          component: AppVerify,
          meta: {
            isLogin: true,
            title: "应用访问验证"
          }
        },
        {
          path: "/loginVerify",
          name: "LoginVerify",
          component: LoginVerify,
          meta: {
            isLogin: true,
            title: "平台登录验证"
          }
        },
        {
          path: "/audit",
          name: "Audit",
          component: Audit,
          meta: {
            isLogin: true,
            title: "日志审计"
          }
        },
        {
          path: "/agent",
          name: "Agent",
          component: Agent,
          meta: {
            isLogin: true,
            title: "代理监控"
          }
        },
        {
          path: "/log",
          name: "Log",
          component: Log,
          meta: {
            isLogin: true,
            title: "服务日志"
          }
        },
        {
          path: "/records",
          name: "Records",
          component: Records,
          meta: {
            isLogin: true,
            title: "认证记录"
          }
        },
        {
          path: "/notice",
          name: "Notice",
          component: Notice,
          meta: {
            isLogin: true,
            title: "监控通知"
          }
        },
        {
          path: "/ip",
          name: "IP",
          component: IP,
          meta: {
            isLogin: true,
            title: "安全IP设置"
          }
        },
        {
          path: "/domain",
          name: "Domain",
          component: Domain,
          meta: {
            isLogin: true,
            title: "域名设置"
          }
        },
        {
          path: "/rootsOld",
          name: "RootsOld",
          component: RootsOld,
          meta: {
            isLogin: true,
            title: "平台权限-旧"
          }
        },
        {
          path: "/roots",
          name: "Roots",
          component: Roots,
          meta: {
            isLogin: true,
            title: "平台权限"
          }
        },
        {
          path: "/rootsUpdate",
          name: "RootsUpdate",
          component: RootsUpdate,
          meta: {
            isLogin: true,
            title: "角色管理"
          }
        },
        {
          path: "/app_proxy",
          name: "AppProxy",
          component: AppProxy,
          meta: {
            isLogin: true,
            title: "应用代理"
          }
        },
        {
          path: "/certificates",
          name: "Certificates",
          component: Certificates,
          meta: {
            isLogin: true,
            title: "证书管理"
          }
        },
        {
          path: "/flow_control",
          name: "FlowControl",
          component: FlowControl,
          meta: {
            isLogin: true,
            title: "流量控制"
          }
        },
        {
          path: "/forward_proxy",
          name: "ForwardProxy",
          component: ForwardProxy,
          meta: {
            isLogin: true,
            title: "正向代理"
          }
        },
        {
          path: "/ipmac",
          name: "IPMac",
          component: IPMac,
          meta: {
            isLogin: true,
            title: "IPMac地址控制"
          }
        },
        {
          path: "/node_config",
          name: "NodeConfig",
          component: NodeConfig,
          meta: {
            isLogin: true,
            title: "节点配置"
          }
        },
        {
          path: "/safety_rules",
          name: "SafetyRules",
          component: SafetyRules,
          meta: {
            isLogin: true,
            title: "安全规则"
          }
        },
      ]
    }
  ]
});
